import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import './AdminEditor.css'

const CATEGORY_LABELS = {
  history: 'History',
  locations: 'Locations',
  factions: 'Factions',
  deities: 'Deities',
  items: 'Items',
  misc: 'Miscellaneous'
}

export default function LoreList() {
  const { data: articles, loading } = useCollection('lore', { orderByField: 'sortOrder' })

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Lore Articles</h1>
        <Link to="/admin/lore/new" className="btn btn-primary">
          + New Article
        </Link>
      </div>

      {articles.length === 0 ? (
        <div className="empty-state">
          <p>No lore articles yet.</p>
          <p className="text-secondary">Create your first article to start building your world.</p>
        </div>
      ) : (
        <div className="admin-list">
          {articles.map(article => {
            const isHidden = article.hidden === true
            return (
              <Link
                key={article.id}
                to={`/admin/lore/${article.id}`}
                className={`admin-list-item ${isHidden ? 'hidden-item' : ''}`}
                style={{ opacity: isHidden ? 0.5 : 1 }}
              >
                {article.coverImageUrl ? (
                  <div className="item-image">
                    <img src={article.coverImageUrl} alt={article.title} />
                  </div>
                ) : (
                  <div className="item-image lore-placeholder">
                    <span>📜</span>
                  </div>
                )}
                <div className="item-info">
                  <h3>
                    {article.title}
                    {isHidden && <span className="hidden-tag">Hidden</span>}
                  </h3>
                  <p className="text-secondary">
                    {article.excerpt || 'No excerpt'}
                  </p>
                </div>
                <span className="item-badge badge-pc">
                  {CATEGORY_LABELS[article.category] || 'Misc'}
                </span>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
